"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveRentalApplicationFees = exports.isRentalApplicationFeePayable = exports.isRentalApplicationFeeSatisfied = exports.classifyRentalApplicationFee = exports.RENTAL_APPLICATION_FEE_SELECTIONS = exports.RENTAL_APPLICATION_FEE_CATEGORIES = exports.RENTAL_APPLICATION_FEE_VALIDITY_INTERVAL_IN_DAYS = void 0;
exports.RENTAL_APPLICATION_FEE_VALIDITY_INTERVAL_IN_DAYS = 30;
const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;
exports.RENTAL_APPLICATION_FEE_CATEGORIES = {
    PAID: 'paid',
    WAIVED: 'waived',
    PARTIAL: 'partial',
    IN_PROGRESS: 'in_progress',
    RETRYABLE: 'retryable'
};
exports.RENTAL_APPLICATION_FEE_SELECTIONS = {
    EFFECTIVE: 'effective',
    SUPERSEDED: 'superseded',
    EXPIRED: 'expired'
};
const CATEGORY_PRIORITY = {
    [exports.RENTAL_APPLICATION_FEE_CATEGORIES.PAID]: 0,
    [exports.RENTAL_APPLICATION_FEE_CATEGORIES.WAIVED]: 1,
    [exports.RENTAL_APPLICATION_FEE_CATEGORIES.PARTIAL]: 2,
    [exports.RENTAL_APPLICATION_FEE_CATEGORIES.IN_PROGRESS]: 3,
    [exports.RENTAL_APPLICATION_FEE_CATEGORIES.RETRYABLE]: 4
};
const IN_PROGRESS_STATUSES = new Set(['initiated', 'processing', 'succeeded']);
const classifyRentalApplicationFee = (fee) => {
    if (fee.expectedAmountInCents > 0 && fee.amountPaidInCents >= fee.expectedAmountInCents) {
        return exports.RENTAL_APPLICATION_FEE_CATEGORIES.PAID;
    }
    if (fee.expectedAmountInCents <= 0) {
        return exports.RENTAL_APPLICATION_FEE_CATEGORIES.WAIVED;
    }
    if (fee.amountPaidInCents > 0 && fee.amountPaidInCents < fee.expectedAmountInCents) {
        return exports.RENTAL_APPLICATION_FEE_CATEGORIES.PARTIAL;
    }
    if (fee.amountPaidInCents < fee.expectedAmountInCents &&
        fee.stripePaymentIntentStatus !== null &&
        IN_PROGRESS_STATUSES.has(fee.stripePaymentIntentStatus)) {
        return exports.RENTAL_APPLICATION_FEE_CATEGORIES.IN_PROGRESS;
    }
    return exports.RENTAL_APPLICATION_FEE_CATEGORIES.RETRYABLE;
};
exports.classifyRentalApplicationFee = classifyRentalApplicationFee;
const isRentalApplicationFeeSatisfied = (category) => category === exports.RENTAL_APPLICATION_FEE_CATEGORIES.PAID ||
    category === exports.RENTAL_APPLICATION_FEE_CATEGORIES.WAIVED;
exports.isRentalApplicationFeeSatisfied = isRentalApplicationFeeSatisfied;
const isRentalApplicationFeePayable = (category) => category === exports.RENTAL_APPLICATION_FEE_CATEGORIES.RETRYABLE;
exports.isRentalApplicationFeePayable = isRentalApplicationFeePayable;
const compareEligibleFees = (left, right) => {
    const categoryDifference = CATEGORY_PRIORITY[left.category] - CATEGORY_PRIORITY[right.category];
    if (categoryDifference !== 0) {
        return categoryDifference;
    }
    const createdAtDifference = new Date(right.fee.createdAt).getTime() - new Date(left.fee.createdAt).getTime();
    if (createdAtDifference !== 0) {
        return createdAtDifference;
    }
    if (left.fee.id === right.fee.id) {
        return 0;
    }
    return left.fee.id < right.fee.id ? 1 : -1;
};
const resolveRentalApplicationFees = (fees, now) => {
    var _a, _b, _c;
    const minimumCreatedAt = now.getTime() - exports.RENTAL_APPLICATION_FEE_VALIDITY_INTERVAL_IN_DAYS * MILLISECONDS_PER_DAY;
    const eligibleFees = fees
        .filter((fee) => new Date(fee.createdAt).getTime() > minimumCreatedAt)
        .map((fee) => ({
        fee,
        category: (0, exports.classifyRentalApplicationFee)(fee),
        selection: exports.RENTAL_APPLICATION_FEE_SELECTIONS.SUPERSEDED
    }))
        .sort(compareEligibleFees);
    const effectiveFeeId = (_b = (_a = eligibleFees.at(0)) === null || _a === void 0 ? void 0 : _a.fee.id) !== null && _b !== void 0 ? _b : null;
    const resolvedFees = fees.map((fee) => {
        const category = (0, exports.classifyRentalApplicationFee)(fee);
        const isEligible = new Date(fee.createdAt).getTime() > minimumCreatedAt;
        return {
            fee,
            category,
            selection: !isEligible
                ? exports.RENTAL_APPLICATION_FEE_SELECTIONS.EXPIRED
                : fee.id === effectiveFeeId
                    ? exports.RENTAL_APPLICATION_FEE_SELECTIONS.EFFECTIVE
                    : exports.RENTAL_APPLICATION_FEE_SELECTIONS.SUPERSEDED
        };
    });
    return {
        effectiveFee: (_c = resolvedFees.find(({ fee }) => fee.id === effectiveFeeId)) !== null && _c !== void 0 ? _c : null,
        fees: resolvedFees
    };
};
exports.resolveRentalApplicationFees = resolveRentalApplicationFees;
